import React, { FC } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import transformProp from 'loankeeper-common/containers/transformProp'
import transformProps from 'loankeeper-common/containers/transformProps'
import flowRight from 'lodash/flowRight'
import isUndefined from 'lodash/isUndefined'
import get from 'lodash/get'
//@ts-ignore
import withLookups from 'shared/containers/withLookups'
//@ts-ignore
import DropdownField from 'shared/FormFields/DropdownField'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'

//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { FormLayout } from 'shared/newFormElements'
import { colors } from 'shared'
import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { addRelationModal, addRelationForm, addRelationFetcher } from '../../../constants'
import { translateRel, translateLKMessage } from '../../../helpers'
import { AddRelationModalProps, Node, transformPropsParams } from 'src/features/ClientDetails/types'
import { AppDispatch } from 'src/store/index.d'
import FormField from 'src/features/shared/newFormElements'
import { addClientRelation } from 'src/store/client'

const AddRelationModal: FC<AddRelationModalProps> = (props) => {
  const { modalInstanceName, fullName, relatedClientFullName, options, handleSubmit, Nodes, form, valid } = props

  return (
    <LKModal
      name={modalInstanceName}
      heading={translateRel('frm_client_rl')}
      size="sm-1"
      footer={
        <LKModal.Footer>
          <LKBaseButton.Okay onClick={handleSubmit} />
        </LKModal.Footer>
      }
    >
      <form>
        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_main_client_t')}>
          <strong style={{ color: colors.black }}>{fullName}</strong>
        </FormLayout>

        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_type_of_relation_t')}>
          <DropdownField name="clientRelType" options={options} />
        </FormLayout>

        <hr style={{ marginTop: 10, marginBottom: 10 }} />

        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_related_individual_t')}>
          <strong style={{ color: colors.red }}>{relatedClientFullName}</strong>
        </FormLayout>

        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_type_of_relation_t')}>
          <DropdownField name="relatedClientRelType" options={options} />
        </FormLayout>

        <hr style={{ marginTop: 10, marginBottom: 10 }} />

        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_node')}>
          <DropdownField name="Node" options={Nodes} />
        </FormLayout>

        <FormLayout labelFieldProportions="5:11" label={translateRel('lbl_cfield1')}>
          <div style={{ position: 'relative' }}>
            <FormField
              type="textarea"
              name="cfield"
              form={form}
              visible={undefined}
              GetError={undefined}
              className={undefined}
              maxLength={100}
            />
            {!valid && (
              <span
                style={{
                  color: colors.red,
                  position: 'absolute',
                  left: '0',
                  bottom: '-17px',
                }}
              >
                მაქს. 100 სიმბოლო
              </span>
            )}
          </div>
        </FormLayout>
      </form>
    </LKModal>
  )
}

export default flowRight(
  LKModalContainer(addRelationModal),
  transformProps(
    ({
      params: {
        row: { Full_Name, ID, HashSum_ClientID_ },
      },
      ...restProps
    }: transformPropsParams) => ({
      ...restProps,
      relatedClientFullName: Full_Name,
      relatedClientID: ID,
      relatedClientHash: HashSum_ClientID_,
    }),
  ),
  withLookups({
    type: 'sys',
    query: ['Client_RLType as options', 'Nodes'],
  }),
  transformProp(
    'options',
    (
      options: Array<{
        ID: number
        Title: string
        Title_ALT: string
        ThirdParty: number
        FamilyMemberFlag: number
        PartnerFlag: number
        BeneficiaryFlag: number
      }>,
    ) =>
      options
        .filter((option) => option.ID > 0)
        .map(({ ID, Title }) => ({
          value: ID,
          text: Title,
        })),
  ),
  transformProp('Nodes', (nodes: Array<Node>) =>
    nodes
      .filter((node) => node.ID > 0)
      .map(({ ID, Title }) => ({
        value: ID,
        text: Title,
      })),
  ),
  connect(
    (
      _state,
      {
        options = [],
        Nodes = [],
      }: { options: Array<{ value: number; text: string }>; Nodes: Array<{ value: number; text: string }> },
    ) => {
      const defRelType: number = get(options, '[0].value')
      const defNode: number = get(Nodes, '[0].value')
      return !isUndefined(defRelType) && !isUndefined(defNode)
        ? { initialValues: { clientRelType: defRelType, relatedClientRelType: defRelType, Node: defNode, cfield: '' } }
        : {}
    },
  ),
  reduxForm({
    form: addRelationForm,
    onSubmit: async (
      {
        clientRelType,
        relatedClientRelType,
        Node,
        cfield,
      }: {
        clientRelType: number
        relatedClientRelType: number
        Node: number
        cfield: string
      },
      dispatch: AppDispatch,
      {
        ID,
        hash,
        relatedClientID,
        relatedClientHash,
      }: {
        ID: string
        hash: string
        relatedClientID: number
        relatedClientHash: string
      },
    ) => {
      dispatch(LKModalActions.close(addRelationModal))
      // dispatch(
      //   fetchSFM({
      //     instanceName: addRelationFetcher,
      //     callApi: (...params) =>  {
      //       console.log(...params)
      //       return Client.addRelation(...params)
      //     },
      //     callApiArgs: [
      //       ID,
      //       hash,
      //       relatedClientID,
      //       relatedClientHash,
      //       relatedClientRelType,
      //       clientRelType,
      //       Node,
      //       cfield,
      //     ],
      //     resolve: () => {
      //       dispatch(
      //         DetailsContainerActions.fetchPage({
      //           type: 'Client',
      //           ID,
      //           hash,
      //           page: 'relations',
      //         }),
      //       )
      //     },
      //     reject: (error) => {
      //       console.log(error)
      //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      // )
      //UPDATED API REQUEST client_oper_post action:relationadd
      const res = await dispatch(
        addClientRelation({
          ID,
          hash,
          relatedClientID,
          relatedClientHash,
          relatedClientRelType,
          clientRelType,
          Node,
          cfield,
        }),
      )
      if (addClientRelation.fulfilled.match(res)) {
        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Client',
            ID,
            hash,
            page: 'relations',
          }),
        )
      } else {
        //@ts-ignore
        dispatch(LKModalActions.openInfo(translateLKMessage(res.payload.message)))
      }
    },
    validate: (values) => {
      const errors: { cfield?: string } = {}
      if (values?.cfield?.length > 100) {
        errors.cfield = 'მაქს. 100 სიმბოლო'
      }
      return errors
    },
  }),
  //@ts-ignore
)(AddRelationModal)
